import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Home from "./menu/home/reducer"
import Application from "./menu/application/reducer"
import Plan from './nonauth/plan/reducer'
import Usage from "./menu/usage/reducer"
import Pricing from "./menu/pricing/reducer"




// Non Authentication
import BillSet from "./nonauth/billingdetails/reducer"

// lystface

const appReducer = combineReducers({
  // public
  BillSet,
  Plan,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Home,
  Application,
  Usage,
  Pricing,
})
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER_SUCCESS' && !state?.Login?.timeout) {
    state = undefined; // Reset all state to initial values
  }
  if (action.type === 'SESSION_TIMEOUT') {
    state = undefined; // Reset all state to initial values
  }
  return appReducer(state, action);
};

export default rootReducer
